import { render, staticRenderFns } from "./OrderColumnOrder.vue?vue&type=template&id=6a21c534&"
import script from "./OrderColumnOrder.vue?vue&type=script&lang=ts&"
export * from "./OrderColumnOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports